import React from "react";
import { areaQueryWithSeoString_area } from "util/seo/types/areaQueryWithSeoString";
import { formatNumber } from "util/strings";

interface IProps {
  marketName?: string;
  areas: areaQueryWithSeoString_area[];
  count: number;
}

const AggregateHeader = ({
  marketName = "your selected area",
  areas,
  count,
}: IProps) => {
  const countString =
    count < 100
      ? formatNumber(count)
      : `${formatNumber(Math.floor(count / 100) * 100)}+`;
  let text = `${countString} listings in `;
  if (areas.length === 0) text += marketName;
  if (areas.length === 1) text += areas[0].name;
  if (areas.length === 2) text += areas.map(({ name }) => name).join(" and ");
  if (areas.length === 3)
    text += `${areas[0].name}, ${areas[1].name} and ${areas[2].name}`;
  if (areas.length > 3) text += "your selected areas";
  // verbose code below to test seo effectivness
  if (marketName === "New York" && areas.length === 0)
    return (
      <h1 className="subheaderEmphasis">
        New York City, NY Office Space for Rent - {countString} listings
      </h1>
    );
  if (marketName === "Los Angeles" && areas.length === 0)
    return (
      <h1 className="subheaderEmphasis">
        Los Angeles, CA Office Space for Rent - {countString} listings
      </h1>
    );
  // end test
  return <h1 className="subheaderEmphasis">{text}</h1>;
};

export default AggregateHeader;
